import React, { memo } from 'react';
import { array, node } from 'prop-types';
import StatisticsTableItem from './StatisticsTableItem';

const propTypes = {
  stats: array,
  replaceFirstWith: node,
};

const defaultProps = {
  stats: [],
};

const StatisticsTableRow = memo(({ stats, replaceFirstWith, status = 'common', isTrash }) =>
  stats.length > 0 ? (
    <tr className={`status-${isTrash ? `trash` : status}`}>
      {stats.map((value, i) =>
        replaceFirstWith && i === 0 ? (
          <StatisticsTableItem key={i} value={replaceFirstWith} />
        ) : (
          <StatisticsTableItem key={i} value={value} />
        ),
      )}
    </tr>
  ) : null,
);

StatisticsTableRow.propTypes = propTypes;
StatisticsTableRow.defaultProps = defaultProps;

export default StatisticsTableRow;
